import React, { useEffect, useMemo, useRef } from 'react';
import {
  Box,
  Button,
  Typography,
  Divider,
  Paper,
  Link,
  CircularProgress,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { cognitoLogin } from '../../redux/actions/auth/AuthActions';
import { loginStyles } from './styles'; // your existing style file

export const Login: React.FC = () => {
  const classes = loginStyles();
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const isFirstRender = useRef(true);
  const authCode = useMemo(
    () => new URLSearchParams(window.location.search).get('code'),
    [],
  );
  
  useEffect(() => {
    if (authCode && isFirstRender.current) {
      isFirstRender.current = false;
      dispatch(cognitoLogin({ code: authCode }, navigate));
    }
  }, [authCode]);

  const handleSubmit = (): any => {
    window.location.href =
      `${import.meta.env.VITE_SSO_URL}/login?clientId=${import.meta.env.VITE_COGNITO_CLIENT_ID}` +
      `&callbackUrl=${import.meta.env.VITE_SSO_CALLBACK_URL}`;
  };

  const handleSignUp = (): any => {
    window.location.href =
      `${import.meta.env.VITE_SSO_URL}/signup?clientId=${import.meta.env.VITE_COGNITO_CLIENT_ID}` +
      `&callbackUrl=${import.meta.env.VITE_SSO_CALLBACK_URL}`;
  };

  const handleResetPassword = (): any => {
    window.location.href =
      `${import.meta.env.VITE_SSO_URL}/forgot-password?clientId=${import.meta.env.VITE_COGNITO_CLIENT_ID}` +
      `&callbackUrl=${import.meta.env.VITE_SSO_CALLBACK_URL}`;
  };

  // If we have an auth code, the login flow is in progress — show a loading state
  if (authCode) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          gap: 2,
        }}
      >
        <CircularProgress size={48} sx={{ color: '#007db3' }} />
        <Typography variant="body1" color="textSecondary">
          Signing you in...
        </Typography>
      </Box>
    );
  }

  return (
    <>
        <Box className={classes.mainDiv}>
          <Box className={classes.loginImage} />

          <Box className={classes.signUpBox}>
            <Paper
              elevation={3}
              sx={{
                p: 4,
                borderRadius: 3,
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
              }}
            >
              <Typography
                variant="overline"
                color="textSecondary"
                gutterBottom
                sx={{ color: 'rgb(99, 115, 138)', fontSize: '1rem', fontWeight: 700 }}
              >
                LOGIN
              </Typography>

              <Typography
                variant="h1"
                fontWeight="800"
                fontSize="2.488rem"
                gutterBottom
                sx={{
                  fontWeight: 'bold!important',
                }}
              >
                Affiliate Portal
              </Typography>

              <Box
                sx={{
                  backgroundColor: '#e6f4ff',
                  borderRadius: 2,
                  p: 2,
                  mb: 2,
                }}
              >
                <Typography
                  variant="subtitle2"
                  fontWeight="bold"
                  gutterBottom
                  sx={{ color: 'rgb(0, 119, 174)' }}
                >
                  Login Notice*
                </Typography>
                <Typography variant="body2" sx={{ color: 'rgb(0, 119, 174)' }}>
                  The Affiliate Portal has been updated. If you have an already existing
                  account, please{' '}
                  <Link
                    underline="hover"
                    color="rgb(0, 119, 174)"
                    fontWeight="bold"
                    sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                    onClick={handleResetPassword}
                  >
                    reset your password
                  </Link>{' '}
                  to log in.
                </Typography>
              </Box>

            

              <Button
                variant="contained"
                onClick={handleSubmit}
                sx={{
                  borderRadius: 8,
                  textTransform: 'none',
                  fontWeight: 'bold',
                  py: 1.2,
                  fontSize: '1rem',
                  width: '180px',
                  height: '56px',
                  backgroundColor: '#007db3',
                  '&:hover': {
                    backgroundColor: '#00699a',
                  },
                }}
              >
                Sign In
              </Button>

              <Divider sx={{ my: 3 }} />

              <Typography variant="body1">
                or{' '}
                <Link
                  component="button"
                  onClick={handleSignUp}
                  underline="hover"
                  fontWeight="bold"
                  color="rgb(0, 119, 174)"
                  sx={{
                    textDecoration: 'underline',
                    paddingLeft: '6px',
                    fontSize: '16px',
                  }}
                >
                  Create a New Account
                </Link>
              </Typography>
            </Paper>
          </Box>
        </Box>
    </>
  );
};

